<div class="dual-bar-chart-container" [ngClass]="{'dark-mode': isDarkMode}">
    <ng-container *ngIf="leftLabelTop || rightLabelTop">
        <div class="top-label">
          <div class="title">
            <div *ngIf="leftLabelTop" class="label-title" [ngStyle]="{ width: titleLeftWidth }">{{ leftLabelTop }}</div>
          </div>
          <div class="title">
            <div *ngIf="rightLabelTop" class="label-title" [ngStyle]="{ width: titleRightWidth }">{{ rightLabelTop }}</div>
          </div>
        </div>
    </ng-container>
    <ng-container>
        <div class="chart-container">
            <div *ngIf="hasLeftChartData() || leftLabelTop != '' " class="line-border line1"></div>
            <div *ngIf="hasLeftChartData() || leftLabelTop != ''" class="line-border line2"></div>
            <div *ngIf="hasRightChartData() || rightLabelTop != ''" class="line-border-right line1"></div>
            <div *ngIf="hasRightChartData() || rightLabelTop != ''" class="line-border-right line2"></div>

            <span class="label-chart-container left-chart">
                <canvas #leftBarChartCanvas></canvas>
                <div class="tube-overlay-row">
                    <div class="tube-cell" *ngFor="let i of groupIndexes">
                        <img *ngIf="tubeIndexYesterday.includes(i)" class="tube-feeding-icon" src="assets/icons/tube-feeding.svg"/>
                    </div>
                </div>
            </span>

            <span class="label-chart-container right-chart">
                <canvas #rightBarChartCanvas></canvas>
                <div class="tube-overlay-row">
                    <div class="tube-cell" *ngFor="let i of groupIndexes">
                        <img *ngIf="tubeIndexToday.includes(i)" class="tube-feeding-icon" src="assets/icons/tube-feeding.svg"/>
                    </div>
                </div>
            </span>
        </div>
    </ng-container>
</div>
